import React from 'react'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "./contactUs.scss"

const ContactUs = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className='contactUs'>
            <div className="contactUs-content__header">
                <div className="contactUs-content__title d-flex justify-content-center text-center">
                    <h2 className="contactUs-title"> {t('about.contactBanner.title')}</h2>
                </div>
                <div className=" contactUs-content__subtitle d-flex justify-content-center text-center">
                    <p className=" contactUs-content__secondary-title">{t('about.contactBanner.subtitle')}</p>
                </div>
                <button className='button-page' 
                    onClick={() => navigate("/Contacto")}>
                    {t('about.contactBanner.button')}
                </button>
            </div>
        </div>
    )
}

export default ContactUs